import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
var homeUrl="Home.vue";
Vue.use(VueRouter)

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
   console.log("mobile device");
   homeUrl="HomeMobile"
 }else{
  console.log("not mobile device");
   homeUrl="Home"
 }

  const routes = [
   {
     path: '/',
     name: 'Home',
     component: () => import(  '../views/'+homeUrl)
   },
   {
    path: '/PmSurya',
    name: 'PmSurya',
    component: () => import( '../views/PmSurya.vue')
  },
  {
    path: '/CompositeBilling',
    name: 'CompositeBilling',
    component: () => import( '../views/CompositeBilling.vue')
  },
  {
    path: '/CompositeBillingDashboard',
    name: 'CompositeBillingDashboard',
    component: () => import( '../views/CompositeBillingDashboard.vue')
  },
   {
     path: '/ActsAndRules',
     name: 'ActsAndRules',
     component: () => import( '../views/ActsAndRules.vue')
   },
  {
     path: '/Award',
     name: 'Award',
     component: () => import( '../views/Award.vue')
  },
  {
     path: '/Newsletter',
     name: 'Newsletter',
     component: () => import( '../views/Newsletter.vue')
  },
  {
     path: '/BijuleeNewsBulletin',
     name: 'BijuleeNewsBulletin',
     component: () => import( '../views/BijuleeNewsBulletin.vue')
  },
  {
    path: '/AS_CheckApplStatus',
    name: 'AS_CheckApplStatus',
    component: () => import( '../views/AS_CheckApplStatus.vue')
 },
  {
    path: '/AS_PmSurya',
    name: 'AS_PmSurya',
    component: () => import( '../views/AS_PmSurya.vue')
 },
  {
     path: '/Testimonial',
     name: 'Testimonial',
     component: () => import( '../views/Testimonial.vue')
  },
  {
     path: '/Workshop',
     name: 'Workshop',
     component: () => import( '../views/Workshop.vue')
  },
  {
    path: '/TenderCurrent',
    name: 'TenderCurrent',
    component: () => import( '../views/TenderCurrent.vue')
  },
  {
    path: '/TenderPrevious',
    name: 'TenderPrevious',
    component: () => import( '../views/TenderPrevious.vue')
  },
  {
    path: '/TenderArchive',
    name: 'TenderArchive',
    component: () => import( '../views/TenderArchive.vue')
  },
  {
    path: '/About',
    name: 'About',
    component: () => import( '../views/About.vue')
  },
  {
    path: '/ApplyNewConn',
    name: 'ApplyNewConn',
    component: () => import( '../views/ApplyNewConn.vue')
  },
  {
    path: '/OnlineChangeProcess',
    name: 'OnlineChangeProcess',
    component: () => import( '../views/OnlineChangeProcess.vue')
  },

  {
    path: '/CheckApplStatus',
    name: 'CheckApplStatus',
    component: () => import( '../views/CheckApplStatus.vue')
  },
  {
    path: '/APDCLGuestHouse',
    name: 'APDCLGuestHouse',
    component: () => import('../views/APDCLGuestHouse.vue')
  },
  {
    path: '/70independenceday',
    name: '70independenceday',
    component: () => import('../views/70independenceday.vue')
  },
  {
    path: '/badminton2016',
    name: 'badminton2016',
    component: () => import('../views/badminton2016.vue')
  },
  {
    path: '/ConsumerRegistration',
    name: 'ConsumerRegistration',
    component: () => import( '../views/ConsumerRegistration.vue')
  },
  {
    path: '/ConsumerDashboard',
    name: 'ConsumerDashboard',
    component: () => import( '../views/ConsumerDashboard.vue')
  },
  {
    path: '/ConsumerDashboardPostpaid',
    name: 'ConsumerDashboardPostpaid',
    component: () => import( '../views/ConsumerDashboardPostpaid.vue')
  },
  {
    path: '/ConsumerDashboardPrepaid',
    name: 'ConsumerDashboardPrepaid',
    component: () => import( '../views/ConsumerDashboardPrepaid.vue')
  },
  {
    path: '/ConsumerDashboardSmartPrepaid',
    name: 'ConsumerDashboardSmartPrepaid',
    component: () => import( '../views/ConsumerDashboardSmartPrepaid.vue')
  },
  {
    path: '/ConsumerDashboardSmartPostpaid',
    name: 'ConsumerDashboardSmartPostpaid',
    component: () => import( '../views/ConsumerDashboardSmartPostpaid.vue')
  },
  {
    path: '/ConsumerDashboardBBPSpage',
    name: 'ConsumerDashboardBBPSpage',
    component: () => import( '../views/ConsumerDashboardBBPSpage.vue')
  },
  
  {
    path: '/AllDocuments',
    name: 'AllDocuments',
    component: () => import( '../views/AllDocuments.vue')
  },
  {
    path: '/Career',
    name: 'Career',
    component: () => import( '../views/Career.vue')
  },
  {
    path: '/PayBill',
    name: 'PayBill',
    component: () => import( '../views/PayBill.vue')
  },
  {
    path: '/SmartPrepaidBalance',
    name: 'SmartPrepaidBalance',
    component: () => import( '../views/SmartPrepaidBalance.vue')
  },
  {
    path: '/AdSmtPrdRct',
    name: 'SmartPrepaidReceipt',
    component: () => import( '../views/SmartPrepaidReceipt.vue')
  },
  
  {
    path: '/ViewBill',
    name: 'ViewBill',
    component: () => import( '../views/ViewBill.vue')
  },
  {
    path: '/KnowConsNo',
    name: 'KnowConsNo',
    component: () => import( '../views/KnowConsNo.vue')
  },
  {
    path: '/KnowConsNoPrepaid',
    name: 'KnowConsNoPrepaid',
    component: () => import( '../views/KnowConsNoPrepaid.vue')
  },

  
  {
    path: '/MiscPetition',
    name: 'MiscPetition',
    component: () => import( '../views/MiscPetition.vue')
  },
  {
    path: '/RechargePrepaid',
    name: 'RechargePrepaid',
    component: () => import( '../views/RechargePrepaid.vue')
  },
  {
    path: '/RechargePrepaidMb',
    name: 'RechargePrepaidMb',
    component: () => import( '../views/RechargePrepaidMb.vue')
  },
  {
    path: '/ReprintVoucher',
    name: 'ReprintVoucher',
    component: () => import( '../views/ReprintVoucher.vue')
  },
  {
    path: '/Gallery',
    name: 'Gallery',
    component: () => import( '../views/Gallery.vue')
  },
  {
    path: '/RTI',
    name: 'RTI',
    component: () => import( '../views/RTI.vue')
  },
  {
    path: '/SubGallery',
    name: 'SubGallery',
    component: () => import('../views/SubGallery.vue')
  },
  {
    path: '/ContactCustomerCare',
    name: 'ContactCustomerCare',
    component: () => import( '../views/ContactCustomerCare.vue')
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import( '../views/Contact.vue')
  },

  {
    path: '/FAQ',
    name: 'FAQ',
    component: () => import( '../views/FAQ.vue')
  },
  {
    path: '/Project',
    name: 'Project',
    component: () => import( '../views/Project.vue')
  },
  {
    path: '/Aiib',
    name: 'Aiib',
    component: () => import( '../views/Aiib.vue')
  },

  {
    path: '/AssociatedSites',
    name: 'AssociatedSites',
    component: () => import( '../views/AssociatedSites.vue')
  },
  {
    path: '/TariffFiling',
    name: 'TariffFiling',
    component: () => import('../views/TariffFiling.vue')
  },
  {
    path: '/BeeEnergyReport',
    name: 'BeeEnergyReport',
    component: () => import('../views/BeeEnergyReport.vue')
  },
  {
    path: '/RenewableEnergyPolicies',
    name: 'RenewableEnergyPolicies',
    component: () => import('../views/RenewableEnergyPolicies.vue')
  },
  {
    path: '/Safety',
    name: 'Safety',
    component: () => import( '../views/Safety.vue')
  },
  {
    path: '/CsrPolicy',
    name: 'CsrPolicy',
    component: () => import( '../views/CsrPolicy.vue')
  },
  {
    path: '/Notices',
    name: 'Notices',
    component: () => import( '../views/Notices.vue')
  },
  // {
  //   path: '/AuditorsReport',
  //   name: 'AuditorsReport',
  //   component: () => import( '../views/AuditorsReport.vue')
  // },
  {
    path: '/BodReport',
    name: 'BodReport',
    component: () => import( '../views/BodReport.vue')
  },
  {
    path: '/AnnualReturnReport',
    name: 'AnnualReturnReport',
    component: () => import( '../views/AnnualReturnReport.vue')
  },
  {
    path: '/Forms',
    name: 'Forms',
    component: () => import( '../views/Forms.vue')
  },
  {
    path: '/ShutdownCircle',
    name: 'ShutdownCircle',
    component: () => import( '../views/ShutdownCircle.vue')
  },
  {
    path: '/ShutdownNotices',
    name: 'ShutdownNotices',
    component: () => import( '../views/ShutdownNotices.vue')
  },
  {
    path: '/Reports',
    name: 'Reports',
    component: () => import( '../views/Reports.vue')
  },
  {
    path: '/Circulars',
    name: 'Circulars',
    component: () => import( '../views/Circulars.vue')
  },
  {
    path: '/PressRelease',
    name: 'PressRelease',
    component: () => import( '../views/PressRelease.vue')
  },
  {
    path: '/OfficeOrders',
    name: 'OfficeOrders',
    component: () => import( '../views/OfficeOrders.vue')
  },
  {
    path: '/Clarifications',
    name: 'Clarifications',
    component: () => import( '../views/Clarifications.vue')
  },
  {
    path: '/EnergySavingTips',
    name: 'EnergySavingTips',
    component: () => import( '../views/EnergySavingTips.vue')
  },
  {
    path: '/DutiesOfConsumer',
    name: 'DutiesOfConsumer',
    component: () => import( '../views/DutiesOfConsumer.vue')
  },
  {
    path: '/TechSpecification',
    name: 'TechSpecification',
    component: () => import( '../views/TechSpecification.vue')
  },
  {
    path: '/AmicableForm',
    name: 'AmicableForm',
    component: () => import( '../views/AmicableForm.vue')
  },
  // {
  //   path: '/MobileUpdate',
  //   name: 'MobileUpdate',
  //   component: () => import( '../views/MobileUpdate.vue')
  // },

  {
    path: '/DuplicateReceipt',
    name: 'DuplicateReceipt',
    component: () => import('../views/DuplicateReceipt.vue')
  },
  {
    path: '/SolarLandApplication',
    name: 'SolarLandApplication',
    component: () => import('../views/SolarLandApplication.vue')
  },
  {
    path: '/WebsitePolicy',
    name: 'WebsitePolicy',
    component: () => import('../views/WebsitePolicy.vue')
  },
  {
    path: '/TanUpdateOtp',
    name: 'TanUpdateOtp',
    component: () => import( '../views/TanUpdateOtp.vue')
  },
  {
    path: '/TanUpdate',
    name: 'TanUpdate',
    component: () => import( '../views/TanUpdate.vue')
  },
  {
    path: '/SurchargeWaiver',
    name: 'SurchargeWaiver',
    component: () => import( '../views/SurchargeWaiver.vue')
  },
  {
    path: '/ApdclPanDetails',
    name: 'ApdclPanDetails',
    component: () => import( '../views/ApdclPanDetails.vue')
  },
  {
    path: '/NewsNotification',
    name: 'NewsNotification',
    component: () => import( '../views/NewsNotification.vue')
  },
  
  {
    path: '/VldScheme',
    name: 'VldScheme',
    component: () => import( '../views/VldScheme.vue')
  },
  {
    path: '/AnnualStatement',
    name: 'AnnualStatement',
    component: () => import( '../views/AnnualStatement.vue')
  },
{
  path: '/QrtlyAccountStatement',
  name: 'QrtlyAccountStatement',
  component: () => import( '../views/QrtlyAccountStatement.vue')
},
{
  path: '/QrtlyAccountStatementLegacy',
  name: 'QrtlyAccountStatementLegacy',
  component: () => import( '../views/QrtlyAccountStatementLegacy.vue')
},
{
  path: '/QrtlyAccountStatementMoP',
  name: 'QrtlyAccountStatementMoP',
  component: () => import( '../views/QrtlyAccountStatementMoP.vue')
},
{
  path: '/EstimateServiceCost',
  name: 'EstimateServiceCost',
  component: () => import( '../views/EstimateServiceCost.vue')
},
{
  path: '/VendorList',
  name: 'VendorList',
  component: () => import( '../views/VendorList.vue')
},
{
  path: '/HoldingNoUpdate',
  name: 'HoldingNoUpdate',
  component: () => import( '../views/HoldingNoUpdate.vue')
},
{
  path: '/SupplyCode',
  name: 'SupplyCode',
  component: () => import( '../views/SupplyCode.vue')
},
{
  path: '/LoadHoldingNo',
  name: 'LoadHoldingNo',
  component: () => import( '../views/LoadHoldingNo.vue')
},
{
  path: '/OneTimeSettlement',
  name: 'OneTimeSettlement',
  component: () => import( '../views/OneTimeSettlement.vue')
},
{
  path: '/OTSStatus',
  name: 'OTSStatus',
  component: () => import( '../views/OneTimeSettlementStatus.vue')
},
{
  path: '/PrintSOSS',
  name: 'PrintSOSS',
  component: () => import( '../views/PrintSOSS.vue')
},
{
  path: '/PrintAck',
  name: 'PrintAck',
  component: () => import( '../views/PrintAck.vue')
},
{
  path: '/RdssProject',
  name: 'RdssProject',
  component: () => import( '../views/RdssProject.vue')
},

{
  path: '/EodbReport',
  name: 'EodbReport',
  component: () => import( '../views/EodbReport.vue')
},
{
  path: '/CorporateSalaryPackage',
  name: 'CorporateSalaryPackage',
  component: () => import( '../views/CorporateSalaryPackage.vue')
},
{
  path: '/EodbSaidiSaifiReport',
  name: 'EodbSaidiSaifiReport',
  component: () => import( '../views/EodbSaidiSaifiReport.vue')
},
{
  path: '/EodbOutageDashboard',
  name: 'EodbOutageDashboard',
  component: () => import( '../views/EodbOutageDashboard.vue')
},
{
  path: '/EodbPlannedOutage',
  name: 'EodbPlannedOutage',
  component: () => import( '../views/EodbPlannedOutage.vue')
},
{
  path: '/EodbThirdPartyVerification',
  name: 'EodbThirdPartyVerification',
  component: () => import( '../views/EodbThirdPartyVerification.vue')
},
{
  path: '/AS_EodbSaidiSaifiReport',
  name: 'AS_EodbSaidiSaifiReport',
  component: () => import( '../views/AS_EodbSaidiSaifiReport.vue')
},
{
  path: '/EodbNscReport',
  name: 'EodbNscReport',
  component: () => import( '../views/EodbNscReport.vue')
},
{
  path: '/EodbePanjeeyanMutationReport',
  name: 'EodbePanjeeyanMutationReport',
  component: () => import( '../views/EodbePanjeeyanMutationReport.vue')
},
{
  path: '/EodbOwnershipChange',
  name: 'EodbOwnershipChange',
  component: () => import( '../views/EodbOwnershipChange.vue')
},
{
  path: '/EodbDomesticDetails',
  name: 'EodbDomesticDetails',
  component: () => import('../views/EodbDomesticDetails.vue')
},
{
  path: '/EodbCommercialDetails',
  name: 'EodbCommercialDetails',
  component: () => import('../views/EodbCommercialDetails.vue')
},
{
  path: '/EodbIndustryDetails',
  name: 'EodbIndustryDetails',
  component: () => import('../views/EodbIndustryDetails.vue')
},
{
  path: '/EodbCommercialDetails',
  name: 'EodbCommercialDetails',
  component: () => import('../views/EodbCommercialDetails.vue')
},
{
  path: '/EodbOtherDetails',
  name: 'EodbOtherDetails',
  component: () => import('../views/EodbOtherDetails.vue')
},
{
  path: '/KnowYourTariff',
  name: 'KnowYourTariff',
  component: () => import( '../views/KnowYourTariff.vue')
},
{
  path: '/TariffOrder',
  name: 'TariffOrder',
  component: () => import( '../views/TariffOrder.vue')
},
{
  path: '/fpppa',
  name: 'fpppa',
  component: () => import( '../views/fpppa.vue')
},
{
  path: '/ChatBot',
  name: 'ChatBot',
  component: () => import( '../views/ChatBot.vue')
},

{
  path: '/PoshPolicy',
  name: 'PoshPolicy',
  component: () => import( '../views/PoshPolicy.vue')
},
{
  path: '/ADRElogin',
  name: 'ADRElogin',
  component: () => import( '../views/ADRElogin.vue')
},
/*{
  path: '/BlacklistedDetails',
  name: 'BlacklistedDetails',
  component: () => import( '../views/BlacklistedDetails.vue')
},*/
  // ASSAMESE Website
  {
    path: '/Assamese',
    name: 'Assamese',
    component: () => import( '../views/AS_Home.vue')
  },
  {
    path: '/AssameseMobile',
    name: 'AssameseMobile',
    component: () => import( '../views/AS_HomeMobile.vue')
  },
  {
    path: '/AS_Contact',
    name: 'AS_Contact',
    component: () => import( '../views/AS_Contact.vue')
  },
  {
    path: '/AS_Project',
    name: 'AS_Project',
    component: () => import( '../views/AS_Project.vue')
  },
  {
    path: '/AS_TenderCurrent',
    name: 'AS_TenderCurrent',
    component: () => import( '../views/AS_TenderCurrent.vue')
  },
  {
    path: '/AS_TenderPrevious',
    name: 'AS_TenderPrevious',
    component: () => import( '../views/AS_TenderPrevious.vue')
  },
  {
    path: '/AS_TenderArchive',
    name: 'AS_TenderArchive',
    component: () => import( '../views/AS_TenderArchive.vue')
  },
  {
    path: '/AS_Award',
    name: 'AS_Award',
    component: () => import( '../views/AS_Award.vue')
  },
  {
    path: '/AS_Newsletter',
    name: 'AS_Newsletter',
    component: () => import( '../views/AS_Newsletter.vue')
  },
  {
    path: '/AS_BijuleeNewsBulletin',
    name: 'AS_BijuleeNewsBulletin',
    component: () => import( '../views/AS_BijuleeNewsBulletin.vue')
  },
  {
    path: '/AS_PressRelease',
    name: 'AS_PressRelease',
    component: () => import( '../views/AS_PressRelease.vue')
  },
  {
    path: '/AS_Testimonial',
    name: 'AS_Testimonial',
    component: () => import( '../views/AS_Testimonial.vue')
  },
  {
    path: '/AS_Workshop',
    name: 'AS_Workshop',
    component: () => import( '../views/AS_Workshop.vue')
  },

  {
    path: '/AS_AllDocuments',
    name: 'AS_AllDocuments',
    component: () => import( '../views/AS_AllDocuments.vue')
  },
  {
    path: '/AS_About',
    name: 'AS_About',
    component: () => import( '../views/AS_About.vue')
  },
  {
    path: '/AS_ActsAndRules',
    name: 'AS_ActsAndRules',
    component: () => import( '../views/AS_ActsAndRules.vue')
  },
  {
    path: '/AS_PayBill',
    name: 'AS_PayBill',
    component: () => import( '../views/AS_PayBill.vue')
  },
  {
    path: '/AS_ViewBill',
    name: 'AS_ViewBill',
    component: () => import( '../views/AS_ViewBill.vue')
  },
  {
    path: '/AS_RechargePrepaid',
    name: 'AS_RechargePrepaid',
    component: () => import( '../views/AS_RechargePrepaid.vue')
  },
  {
    path: '/AS_ApplyNewConn',
    name: 'AS_ApplyNewConn',
    component: () => import( '../views/AS_ApplyNewConn.vue')
  },
  {
    path: '/AS_OnlineChangeProcess',
    name: 'AS_OnlineChangeProcess',
    component: () => import( '../views/AS_OnlineChangeProcess.vue')
  },
  // {
  //   path: '/AS_MobileUpdate',
  //   name: 'AS_MobileUpdate',
  //   component: () => import( '../views/AS_MobileUpdate.vue')
  // },
  {
    path: '/AS_ConsumerRegistration',
    name: 'AS_ConsumerRegistration',
    component: () => import( '../views/AS_ConsumerRegistration.vue')
  },
  {
    path: '/AS_DuplicateReceipt',
    name: 'AS_DuplicateReceipt',
    component: () => import('../views/AS_DuplicateReceipt.vue')
  },
  {
    path: '/AS_ReprintVoucher',
    name: 'AS_ReprintVoucher',
    component: () => import( '../views/AS_ReprintVoucher.vue')
  },
  {
    path: '/AS_AmicableForm',
    name: 'AS_AmicableForm',
    component: () => import( '../views/AS_AmicableForm.vue')
  },
  {
    path: '/AS_TanUpdate',
    name: 'AS_TanUpdate',
    component: () => import( '../views/AS_TanUpdate.vue')
  },
  {
    path: '/AS_Gallery',
    name: 'AS_Gallery',
    component: () => import( '../views/AS_Gallery.vue')
  },
  {
    path: '/AS_RTI',
    name: 'AS_RTI',
    component: () => import( '../views/AS_RTI.vue')
  },
  {
    path: '/AS_Career',
    name: 'AS_Career',
    component: () => import( '../views/AS_Career.vue')
  },
  {
    path: '/AS_FAQ',
    name: 'AS_FAQ',
    component: () => import( '../views/AS_FAQ.vue')
  },
  {
    path: '/AS_WebsitePolicy',
    name: 'AS_WebsitePolicy',
    component: () => import( '../views/AS_WebsitePolicy.vue')
  },
  {
    path: '/AS_Aiib',
    name: 'AS_Aiib',
    component: () => import( '../views/AS_Aiib.vue')
  },
  {
    path: '/AS_AnnualStatement',
    name: 'AS_AnnualStatement',
    component: () => import( '../views/AS_AnnualStatement.vue')
  },
  {
    path: '/AS_QrtlyAccountStatement',
    name: 'AS_QrtlyAccountStatement',
    component: () => import( '../views/AS_QrtlyAccountStatement.vue')
  },
  {
    path: '/AS_QrtlyAccountStatementLegacy',
    name: 'AS_QrtlyAccountStatementLegacy',
    component: () => import( '../views/AS_QrtlyAccountStatementLegacy.vue')
  },
  {
    path: '/AS_QrtlyAccountStatementMoP',
    name: 'AS_QrtlyAccountStatementMoP',
    component: () => import( '../views/AS_QrtlyAccountStatementMoP.vue')
  },
  {
    path: '/AS_AnnualReturnReport',
    name: 'AS_AnnualReturnReport',
    component: () => import( '../views/AS_AnnualReturnReport.vue')
  },
  // {
  //   path: '/AS_AuditorsReport',
  //   name: 'AS_AuditorsReport',
  //   component: () => import( '../views/AS_AuditorsReport.vue')
  // },
  {
    path: '/AS_BodReport',
    name: 'AS_BodReport',
    component: () => import( '../views/AS_BodReport.vue')
  },
  {
    path: '/AS_Forms',
    name: 'AS_Forms',
    component: () => import( '../views/AS_Forms.vue')
  },
  {
    path: '/AS_Notices',
    name: 'AS_Notices',
    component: () => import( '../views/AS_Notices.vue')
  },
  {
    path: '/AS_ShutdownCircle',
    name: 'AS_ShutdownCircle',
    component: () => import( '../views/AS_ShutdownCircle.vue')
  },
  {
    path: '/AS_ShutdownNotices',
    name: 'AS_ShutdownNotices',
    component: () => import( '../views/AS_ShutdownNotices.vue')
  },
  {
    path: '/AS_Reports',
    name: 'AS_Reports',
    component: () => import( '../views/AS_Reports.vue')
  },
  {
    path: '/AS_Circulars',
    name: 'AS_Circulars',
    component: () => import( '../views/AS_Circulars.vue')
  },
  {
    path: '/AS_PressRelease',
    name: 'AS_PressRelease',
    component: () => import( '../views/AS_PressRelease.vue')
  },
  {
    path: '/AS_OfficeOrders',
    name: 'AS_OfficeOrders',
    component: () => import( '../views/AS_OfficeOrders.vue')
  },
  {
    path: '/AS_Clarifications',
    name: 'AS_Clarifications',
    component: () => import( '../views/AS_Clarifications.vue')
  },
  {
    path: '/AS_EnergySavingTips',
    name: 'AS_EnergySavingTips',
    component: () => import( '../views/AS_EnergySavingTips.vue')
  },
  {
    path: '/AS_DutiesOfConsumer',
    name: 'AS_DutiesOfConsumer',
    component: () => import( '../views/AS_DutiesOfConsumer.vue')
  },
  {
    path: '/AS_TechSpecification',
    name: 'AS_TechSpecification',
    component: () => import( '../views/AS_TechSpecification.vue')
  },
  {
    path: '/AS_CsrPolicy',
    name: 'AS_CsrPolicy',
    component: () => import( '../views/AS_CsrPolicy.vue')
  },
  {
    path: '/AS_CheckApplStatus',
    name: 'AS_CheckApplStatus',
    component: () => import( '../views/AS_CheckApplStatus.vue')
 },
  {
    path: '/AS_PmSurya',
    name: 'AS_PmSurya',
    component: () => import( '../views/AS_PmSurya.vue')
 },
 {
  path: '/AS_HoldingNoUpdate',
  name: 'AS_HoldingNoUpdate',
  component: () => import( '../views/AS_HoldingNoUpdate.vue')
},
{
  path: '/AS_VldScheme',
  name: 'AS_VldScheme',
  component: () => import( '../views/AS_VldScheme.vue')
},
{
  path: '/AS_SmartPrepaidBalance',
  name: 'AAS_SmartPrepaidBalance',
  component: () => import( '../views/AS_SmartPrepaidBalance.vue')
},
{
  path: '/AS_EodbReport',
  name: 'AS_EodbReport',
  component: () => import( '../views/AS_EodbReport.vue')
},
{
  path: '/AS_EstimateServiceCost',
  name: 'AS_EstimateServiceCost',
  component: () => import( '../views/AS_EstimateServiceCost.vue')
},
{
  path: '/AS_BeeEnergyReport',
  name: 'AS_BeeEnergyReport',
  component: () => import('../views/AS_BeeEnergyReport.vue')
},
{
  path: '/AS_PoshPolicy',
  name: 'AS_PoshPolicy',
  component: () => import( '../views/AS_PoshPolicy.vue')
},
{
  path: '/AS_TariffOrder',
  name: 'AS_TariffOrder',
  component: () => import( '../views/AS_TariffOrder.vue')
},
{
  path: '/AS_TariffFiling',
  name: 'AS_TariffFiling',
  component: () => import( '../views/AS_TariffFiling.vue')
},
{
  path: '/AS_KnowYourTariff',
  name: 'AS_KnowYourTariff',
  component: () => import( '../views/AS_KnowYourTariff.vue')
},
 {
    path: '/AS_AssociatedSites',
    name: 'AS_AssociatedSites',
    component: () => import( '../views/AS_AssociatedSites.vue')
  },
//ADMIN Router
{
   path: '/AdminLogin',
   name: 'AdminLogin',
   component: () => import('../views/AdminLogin.vue')
 },
 {
   path: '/admin/admin_dashboard',
   name: 'AdminDashboard',
   component: () => import('../views/AdminDashboard.vue')
 },
 {
   path: '/dcPortal/dc_dashboard',
   name: 'AdminPrepaidDashboard',
   component: () => import('../views/AdminPrepaidDashboard.vue')
 },
 {
   path: '/dcPortal/updatePrepaidConsDetails',
   name: 'AdminPrepaidConsumerMaster',
   component: () => import('../views/AdminPrepaidConsumerMaster.vue')
 },

  {
    path: '/AdminComplaintStatus',
    name: 'AdminComplaintStatus',
    component: () => import('../views/AdminComplaintStatus.vue')
  },
  {
    path: '/AdminCreateTender',
    name: 'AdminCreateTender',
    component: () => import( '../views/AdminCreateTender.vue')
  },
  {
    path: '/AdminUpdateTenderDocs',
    name: 'AdminUpdateTenderDocs',
    component: () => import( '../views/AdminUpdateTenderDocs.vue')
  },
  {
    path: '/AdminUploadDocuments',
    name: 'AdminUploadDocuments',
    component: () => import( '../views/AdminUploadDocuments.vue')
  },
  {
    path: '/AdminPublishTender',
    name: 'AdminPublishTender',
    component: () => import( '../views/AdminPublishTender.vue')
  },

  {
    path: '/AdminUpdateContact',
    name: 'AdminUpdateContact',
    component: () => import( '../views/AdminUpdateContact.vue')
  },
  {
    path: '/AdminCreateContact',
    name: 'AdminCreateContact',
    component: () => import( '../views/AdminCreateContact.vue')
  },
  {
    path: '/AdminUserCreate',
    name: 'AdminUserCreate',
    component: () => import('../views/AdminUserCreate.vue')
  },
  {
    path: '/AdminViewUsers',
    name: 'AdminViewUsers',
    component: () => import('../views/AdminViewUsers.vue')
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/website')) {
    const actualPath = to.path.replace('/website', '');

    const routeExists = router.options.routes.some(
      route => route.path === actualPath
    );

    if (routeExists) {
      next();
    } else {
      next('/404');
    }
  } else {
    next();
  }
});

export default router
